import { render, staticRenderFns } from "./ClientClassification.vue?vue&type=template&id=59e08839&"
import script from "./ClientClassification.vue?vue&type=script&lang=js&"
export * from "./ClientClassification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports